<template>
  <div class="chart-component" v-loading="chartLoading">
    <div class="table-content">
      <el-table class="table-item" :data="tableData" :span-method="mergeColumnHandle" border>
        <el-table-column align="center" :resizable="false" prop="title"></el-table-column>
        <el-table-column
          v-for="item in columnChildArr"
          :key="item.key"
          align="center"
          :label="item.label"
          :resizable="false"
        >
          <template slot="header">
            <el-tooltip :disabled="!item.tip" effect="dark" placement="top">
              <div slot="content" v-html="item.tip"></div>
              <div :style="{ width: '100%', height: '100%' }">{{ item.label }}</div>
            </el-tooltip>
          </template>
          <el-table-column
            v-for="subItem in item.children"
            :key="subItem.key"
            align="center"
            :label="subItem.label"
            :resizable="false"
          >
            <template slot="header">
              <el-tooltip :disabled="!subItem.tip" effect="dark" placement="top">
                <div slot="content" v-html="subItem.tip"></div>
                <div :style="{ width: '100%', height: '100%' }">{{ subItem.label }}</div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <template v-if="subItem.isMerge && scope.row.columnKey === 'const'">
                <span>{{ info[subItem.key] }}</span>
              </template>
              <template v-else>
                <template v-if="scope.row.columnKey === 'const'">
                  <span>{{ info[subItem.key] && info[subItem.key].const }}</span>
                </template>
                <span v-else>{{ info[subItem.key] && info[subItem.key][scope.row.title] }}</span>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          v-for="item in columnArr"
          :key="item.key"
          align="center"
          :label="item.label"
          :resizable="false"
        >
          <template slot="header">
            <el-tooltip :disabled="!item.tip" effect="dark" placement="top">
              <div slot="content" v-html="item.tip"></div>
              <div :style="{ width: '100%', height: '100%' }">{{ item.label }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <template v-if="item.isMerge && scope.row.columnKey === 'const'">
              <span>{{ info[item.key] }}</span>
            </template>
            <template v-else>
              <template v-if="scope.row.columnKey === 'const'">
                <span>{{ info[item.key] && info[item.key].const }}</span>
              </template>
              <span v-else>{{ info[item.key] && info[item.key][scope.row.title] }}</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div class="remind-text" v-if="info.remind_text">
        <span v-html="info.remind_text"></span>
      </div>
    </div>
    <div class="analysis-tip-content" v-if="!byDashboard && (reportArr.length > 0 || warningReport)">
      <div class="report-item" v-for="reportItem in reportArr" :key="reportItem.uniqueId">
        <span v-html="reportItem.text"></span>
      </div>
      <div class="warning-item" v-if="warningReport">
        <i class="el-icon-warning warning-icon"></i>
        <span>{{ warningReport }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import chartComponent from './mixins/chart-component';
import { uniqueId } from 'lodash';

export default {
  mixins: [chartComponent],
  data() {
    return {
      rows: [],
      info: {},
      report: '',
      warningReport: '',
      columnChildArr: [
        {
          key: 'parent-1',
          isMerge: false,
          label: '非标准化系数',
          tip: '用原始数据计算出来的系数',
          children: [
            { key: 'beta_coefficient', isMerge: false, label: 'B' },
            {
              key: 'standard_error',
              isMerge: false,
              label: '标准误差',
              tip:
                '代表实际值与估计值之间的偏离程度，用来衡量回归方程的代表性<br />标准误差的值越小越好<br />标准误差接近0时，说明实际情况与预估情况几乎完全一样，代表性极强'
            }
          ]
        }
      ], // 修改列头需要同时修改 chartDownload 组件，避免导出的excel列头出错
      columnArr: [
        {
          key: 'beta_standard',
          isMerge: false,
          label: '标准化系数',
          tip:
            '减均值除方差后的数据计算出的系数，我们一般采用标准化系数<br />代表各个自变量对因变量的影响大小，到底存在着正向的影响还是反向的影响'
        },
        {
          key: 'beta_probability',
          isMerge: false,
          label: '标准化系数占比',
          tip: '标准化系数的相对指标，表示各个自变量对因变量的影响程度',
          format: val => {
            if (val === '-') {
              return val;
            }
            return `${val}%`;
          }
        },
        { key: 't_test', isMerge: false, label: 'T' },
        {
          key: 't_sig',
          isMerge: false,
          label: 'Sig',
          tip:
            '单个因素显著性的检验指标<br />判断各个自变量对因变量的影响是否显著<br />此模型的置信水平为95%，其显著性临界值为0.05；即当该值小于0.05时，该行所在的自变量对因变量的影响是显著的；反之，当该值大于0.05时，该行所在的自变量对因变量的影响不显著'
        },
        {
          key: 'vif',
          isMerge: false,
          label: 'VIF',
          tip:
            '方差膨胀系数，多重共线性检验指标<br />判断自变量之间是否存在多重共线性而使研究失真；如果存在，其程度如何<br />VIF小于10，表明不存在多重共线性；VIF大于等于10，小于100，表明存在较强的多重共线性；VIF大于等于100，表明存在严重的多重共线性'
        },
        {
          key: 'dw_value',
          isMerge: true,
          label: 'DW',
          tip:
            '自相关性检验指标<br />判断随机误差项之间是否存在相关性而使研究失真；如果存在，存在正相关性还是负相关性<br />DW取值在0-4之间；DW值越接近2，随机误差项之间越不存在相关性；DW值越接近0，随机误差项之间正相关性越强；DW值越接近4，随机误差项之间负相关性越强'
        },
        {
          key: 'r_value',
          isMerge: true,
          label: 'R方',
          tip:
            '拟合优度指标<br />衡量的是回归方程整体的拟合度，表达因变量与所有自变量之间的总体关系，即所有的自变量对因变量的总体影响程度<br />该指标的取值范围在0到1之间'
        },
        { key: 'f_value', isMerge: true, label: 'F' },
        {
          key: 'f_sig',
          isMerge: true,
          label: 'Sig',
          tip:
            '总体显著性的检验指标<br />用来判断研究的自变量从整体上是否能够影响到因变量<br />此模型的置信水平为95%，其显著性临界值为0.05；即当该值小于0.05时，表明从整体上看，所选自变量对因变量的影响显著；反之，当该值大于0.05时，表明所选自变量对因变量的影响不显著'
        }
      ]
    };
  },
  computed: {
    chartType() {
      return 'tableAnalysisChart';
    },
    reportArr() {
      if (!this.report) {
        return [];
      }
      return this.report.split('\n').map(text => {
        return { uniqueId: uniqueId(), text };
      });
    },
    tableData() {
      if (Object.keys(this.info).length < 1 || this.rows.length < 1) {
        return [];
      }
      return [
        {
          columnKey: 'const',
          title: '常数'
        },
        ...this.rows
      ];
    },
    columnCount() {
      let columnCount = 0;
      const columnArr = [...this.columnChildArr, ...this.columnArr];
      let index = 0;
      while (index < columnArr.length) {
        const item = columnArr[index];
        if ((item.children || []).length > 0) {
          columnArr.push(...item.children);
        } else {
          columnCount++;
        }
        index++;
      }
      return columnCount;
    }
  },
  methods: {
    initDataHandle(params) {
      this.info = params.originData.analysis_data || {};
      this.report = params.originData.analysis_report;
      this.warningReport = params.originData.warn_report || '';
      this.rows = params.rows;
      return { type: this.chartType, isChart: false };
    },
    mergeColumnHandle({ rowIndex, columnIndex }) {
      if (this.columnCount - 4 < columnIndex) {
        if (rowIndex == 0) {
          return { rowspan: this.tableData.length, colspan: 1 };
        } else {
          return { rowspan: 0, colspan: 1 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-component {
  height: 100%;
  overflow: auto;

  .table-content {
    width: 100%;

    .remind-text {
      margin: 10px 0;
      font-size: 12px;
      line-height: 20px;
      color: #2c3443;
      white-space: pre-wrap;
    }

    ::v-deep .table-item {
      width: 100%;
      .el-table__header-wrapper {
        th {
          text-align: center;
          background-color: #f5f7fa;
        }
      }

      td {
        position: relative;

        .cell {
          position: relative;
          z-index: 2;
        }
        &:hover {
          &::after {
            content: ' ';
            position: absolute;
            width: 100%;
            height: 10000px;
            left: 0;
            top: -5000px;
            background-color: #f5f7fa;
            z-index: 1;
          }
        }
      }
    }
  }

  .analysis-tip-content {
    color: #3d465a;
    line-height: 20px;
    font-size: 12px;
    margin-bottom: 10px;

    .report-item {
      margin-bottom: 10px;
      background: #f5f7fa;
      padding: 5px 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .warning-item {
      color: rgba(#fb7519, 0.8);
      padding: 6px 10px;
      margin: 10px 0;
      background-color: rgba(#fdd16c, 0.2);
      border-radius: 4px;
      word-break: break-all;

      &:first-child {
        margin-top: 0;
      }

      .warning-icon {
        font-size: 14px;
        position: relative;
        top: 1px;
        margin-right: 4px;
      }
    }
  }
}
</style>
